import { focusAfterContentInInput } from '../../helpers/input';

export function init(): void {
  focusAfterContentInInput(document.getElementById('trackingBarcode') as HTMLInputElement);
}
